import { BaseType } from '../../base/base-type';
import { MemberContributionSourceEnum } from '../../enum/shared/member-contribution-source-enum';

export class MemberContributionSourceType extends BaseType {
  public declare id: MemberContributionSourceEnum;
}
